<template>
  <div
    :class="[{'no_list' : dataRecentList.length === 0}]"
    class="wrap_search rcnt_search_keyword"
  >
    <div class="wrap_tit">
      <p class="tit">최근 검색어</p>
      <button
        v-if="dataRecentList && dataRecentList.length > 0"
        class="btn_remove_all_rcnt_list"
        @click.stop="clearAll"
      >전체삭제</button>
    </div>
    <div class="list rcnt_search_list">
      <ul class="wrap_keyword_btn">
        <!-- 최근 검색어 존재하는 경우 -->
        <template v-if="dataRecentList && dataRecentList.length > 0" >
          <li
            v-for="(item, index) in dataRecentList"
            :key="index"
          >
            <button
              class="keyword_btn"
              @click.stop="onKeywordClick(item)"
            >
              <span class="txt">{{ item }}</span>
              <button
                class="remove_btn"
                @click.stop="removeSearch(index)"
              >검색어 삭제</button>
            </button>
          </li>
        </template>
        <!-- // 최근 검색어 존재하는 경우 -->

        <!-- 최근 검색어 존재하지 않는 경우 -->
        <template v-else>
          <li class="no_list">
            <span class="txt">최근 검색 내역이 없습니다.</span>
          </li>
        </template>
        <!-- // 최근 검색어 존재하지 않는 경우 -->

      </ul>
    </div>
  </div>
  <!-- // 최근 검색어 UI -->
</template>

<script>
import moment from 'moment'

export default {
  name: 'TotalSearchRecent',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: 통합검색'
    }
  },
  data () {
    return {
      recentSearches: [],
      dataRecentList: [], // 최신 검색 키워드
      isTyping: false, // 검색어 입력중 여부
      isSearchEnd: false // 검색어 입력 완료, 검색결과 노출시 true
    }
  },
  created () {
    this.getRecent()
  },
  mounted () {
  },
  methods: {
    // 최신 검색 키워드
    getRecent () {
      let recent = window.localStorage.getItem('recent')
      if (recent !== null && recent !== undefined) {
        this.dataRecentList = JSON.parse(recent).text
      } else {
        this.dataRecentList = []
      }
    },
    removeSearch (index) {
      this.dataRecentList.splice(index, 1)
      this.saveSearches()
    },
    clearAll () {
      this.dataRecentList = []
      this.saveSearches()
    },
    saveSearches () {
      const expireDate = moment().add(30, 'days')
      localStorage.setItem('recent', JSON.stringify({text: this.dataRecentList, expireDate}))
    },
    // 키워드 클릭
    onKeywordClick (val) {
      this.$emit('onKeywordClick', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/search/TotalSearchRecent.vue